<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('COMPANIES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn dark color="indigo" @click="$router.push({ name: 'companies' })">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" tile :loading="loading">
      <v-card-text>
        <v-form v-model="valid">
          <company-form
            v-model="form"
            :errors="errors.getAll()"
            @update-prop="clearErrorByName($event)"
          >
          </company-form>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          type="submit"
          :disabled="!valid"
          large
          color="primary"
          @click.prevent="createCompany"
        >
          {{ $t('BUTTON.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { mapActions, mapGetters } from 'vuex';
import CompanyForm from '@/modules/companies/components/Company/CompanyForm';

export default {
  name: 'CompanyCreatePage',

  components: { CompanyForm },

  mixins: [errors],

  data() {
    return {
      form: {
        language_id: 1,
        upload: null,
        abacus_id: ''
      },
      valid: false
    };
  },

  computed: {
    ...mapGetters(['loading'])
  },

  methods: {
    ...mapActions('company', ['store']),

    createCompany() {
      this.store(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.push({ name: 'companies' });
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
